
import {
  Box,
  Paper,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

const RawTableSkeleton = () => {
  return (
    <Paper sx={{ p: 2 }}>
      {/* Filters */}
      <Stack
        direction="row"
        spacing={2}
        sx={{ mb: 2, overflowX: "auto" }}
      >
        {[...Array(8)].map((_, index) => (
          <Skeleton
            key={index}
            variant="rounded"
            width={120}
            height={40}
          />
        ))}
      </Stack>

      {/* Table */}
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {[...Array(9)].map((_, index) => (
                <TableCell key={index}>
                  <Skeleton width="80%" height={24} />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {[...Array(15)].map((_, rowIndex) => (
              <TableRow key={rowIndex}>
                {[...Array(9)].map((_, colIndex) => (
                  <TableCell key={colIndex}>
                    <Skeleton
                      variant="text"
                      width={colIndex === 3 ? 180 : 60}
                      height={24}
                    />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <Box
        sx={{
          mt: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Skeleton width={120} height={24} />
        <Skeleton width={200} height={32} />
      </Box>
    </Paper>
  );
};

export default RawTableSkeleton;